import { APP_URLs, config } from "../constants/appURLs";
import { snackActions } from "../helpers/SnackUtilsConfigurator";
import httpClient from "./httpClient";

const deleteCategoryEvent = async (payloadData: any) => {
  try {
    const { data } = await httpClient.delete(
      `${APP_URLs.event.deleteCategoryEvents}/${payloadData?.id}`,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};
const deleteEvents = async (payloadData: any) => {
  try {
    const { data } = await httpClient.delete(
      `${APP_URLs.event.deleteEvents}/${payloadData?.id}`,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};
const deleteLocation = async (payloadData: any) => {
  try {
    const { data } = await httpClient.delete(
      `${APP_URLs.location.deleteLocation}/${payloadData?.id}`,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

// Common
const getCountries = async () => {
  try {
    const { data } = await httpClient.get(
      APP_URLs.commonEndPoints.getCountries,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};
const getProfileImg = async () => {
  try {
    const { data } = await httpClient.get(
      APP_URLs.commonEndPoints.getProfile,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const getEventCategory = async () => {
  try {
    const { data } = await httpClient.get(
      APP_URLs.commonEndPoints.getEventCategory,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};
const getLocationLists = async () => {
  try {
    const { data } = await httpClient.get(
      APP_URLs.commonEndPoints.getLocation,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const getStates = async (payloadData: any) => {
  try {
    const { data } = await httpClient.get(
      `${APP_URLs.commonEndPoints.getStates}/${payloadData?.countryId}/?Skip=0&Take=10000`,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const getCities = async (payloadData: any) => {
  try {
    const { data } = await httpClient.get(
      `${APP_URLs.commonEndPoints.getCities}/${payloadData?.stateId}/?Skip=0&Take=10000`,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const uploadPicture = async (payloadData: any) => {
  config.headers["ContentType"] = "multipart/form-data";
  // config.headers["Content-Type"] = "multipart/form-data";
  try {
    const { data } = await httpClient.post(
      APP_URLs.mediaUpload,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const getTerms = async () => {
  try {
    const { data } = await httpClient.get(
      APP_URLs.termsAndCondition.getTerms,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const getPrivacy = async () => {
  try {
    const { data } = await httpClient.get(
      APP_URLs.privacyAndPolicy.getPrivacy,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const getAboutUs = async () => {
  try {
    const { data } = await httpClient.get(APP_URLs.aboutUs.getAboutUs, config);
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};
const getUsers = async () => {
  try {
    const { data } = await httpClient.get(
      APP_URLs.commonEndPoints.getUsers,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const blockUsers = async (payloadData: any) => {
  try {
    const { data } = await httpClient.put(
      `${APP_URLs.commonEndPoints.blockUsers}/${payloadData?.userId}?isBanned=${payloadData?.isBanned}`,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const addAboutUs = async (payloadData: any) => {
  try {
    const { data } = await httpClient.put(
      APP_URLs.aboutUs.addAboutUs,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const addTerms = async (payloadData: any) => {
  try {
    const { data } = await httpClient.put(
      APP_URLs.termsAndCondition.addTerms,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const addEvent = async (payloadData: any) => {
  try {
    const { data } = await httpClient.post(
      APP_URLs.event.addEvents,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const addParticipants = async (payloadData: any) => {
  try {
    const { data } = await httpClient.post(
      APP_URLs.event.addParticipants,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const editEvent = async (payloadData: any) => {
  try {
    const { data } = await httpClient.put(
      APP_URLs.event.addEvents,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const addEventCategory = async (payloadData: any) => {
  try {
    const { data } = await httpClient.post(
      APP_URLs.event.addCategoryEvents,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};
const editEventCategory = async (payloadData: any) => {
  try {
    const { data } = await httpClient.put(
      APP_URLs.event.addCategoryEvents,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const addPrivacy = async (payloadData: any) => {
  try {
    const { data } = await httpClient.put(
      APP_URLs.privacyAndPolicy.addPrivacy,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};
const addAdmin = async (payloadData: any) => {
  try {
    const { data } = await httpClient.post(
      APP_URLs.AdminUser.addAdmin,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};
const editAdmin = async (payloadData: any) => {
  try {
    const { data } = await httpClient.put(
      APP_URLs.AdminUser.editAdmin,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const deleteAdmin = async (payloadData: any) => {
  try {
    const { data } = await httpClient.delete(
      `${APP_URLs.AdminUser.deleteAdmin}/${payloadData?.id}`,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const addInfoTab = async (payloadData: any) => {
  try {
    const { data } = await httpClient.post(
      APP_URLs.infotabs.getAllInfoTabs,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};
const addInfoNote = async (payloadData: any) => {
  try {
    const { data } = await httpClient.post(
      APP_URLs.infotabs.addNote,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};
const addInfoWebURL = async (payloadData: any) => {
  try {
    const { data } = await httpClient.post(
      APP_URLs.infotabs.addWebURL,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};
const addInfoRSVP = async (payloadData: any) => {
  try {
    const { data } = await httpClient.post(
      APP_URLs.infotabs.addRsvp,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};
const addInfoSocial = async (payloadData: any) => {
  try {
    const { data } = await httpClient.post(
      APP_URLs.infotabs.addSocial,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};
const addInfoImage = async (payloadData: any) => {
  try {
    const { data } = await httpClient.post(
      APP_URLs.infotabs.addImage,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};
const addInfoCheckList = async (payloadData: any) => {
  try {
    const { data } = await httpClient.post(
      APP_URLs.infotabs.addCheckList,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};
const addChoiceList = async (payloadData: any) => {
  try {
    const { data } = await httpClient.post(
      APP_URLs.infotabs.addChoiceList,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const addInfoPoll = async (payloadData: any) => {
  try {
    const { data } = await httpClient.post(
      APP_URLs.infotabs.addPoll,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const addInfoDoc = async (payloadData: any) => {
  try {
    const { data } = await httpClient.post(
      APP_URLs.infotabs.addDocument,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};
const editInfoTab = async (payloadData: any) => {
  try {
    const { data } = await httpClient.put(
      APP_URLs.infotabs.getAllInfoTabs,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const deleteInfo = async (payloadData: any) => {
  try {
    const { data } = await httpClient.delete(
      `${APP_URLs.infotabs.getAllInfoTabs}/${payloadData?.id}`,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const getAppCustomerList = async (query: any) => {
  try {
    const { data } = await httpClient.get(
      `${APP_URLs.appUser.appCustomerList}?roleId=${query?.roleId}&offset=${query?.offset}&limit=${query?.limit}&search=${query?.search}`,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const sendOTP = async (query: any) => {
  try {
    const { data } = await httpClient.post(
      `${APP_URLs.authEndPoints.sendOTP}?email=${query?.email}`,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const verifyOTP = async (payloadData: any) => {
  try {
    const { data } = await httpClient.post(
      APP_URLs.authEndPoints.verifyOTP,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const resetPassword = async (payloadData: any) => {
  try {
    const { data } = await httpClient.post(
      APP_URLs.authEndPoints.resetPassword,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const getAllUserList = async (query: any) => {
  try {
    const { data } = await httpClient.get(
      `${APP_URLs.event.getAllUserList}?id=${query?.id}&Skip=${
        query?.skip
      }&Take=${query?.take}&SearchText=${
        query?.search
      }&OrderByColumn=${"CreatedOn"}&OrderByDirection=${"DESC"}`,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const getAllEventList = async (query: any) => {
  try {
    const params = new URLSearchParams({
      Skip: String(query?.skip ?? 0),
      Take: String(query?.take ?? 10),
      SearchText: query?.SearchText ?? "",
    });

    if (query?.startDate) {
      params.append("startDate", query.startDate);
    }

    if (query?.endDate) {
      params.append("endDate", query.endDate);
    }

    const { data } = await httpClient.get(
      `${APP_URLs.event.getAllEvents}?${params.toString()}`,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const getPopularEventList = async (query: any) => {
  try {
    const params = new URLSearchParams({
      Skip: String(query?.skip ?? 0),
      Take: String(query?.take ?? 10),
      SearchText: query?.SearchText ?? "",
    });

    if (query?.startDate) {
      params.append("startDate", query.startDate);
    }

    if (query?.endDate) {
      params.append("endDate", query.endDate);
    }

    const { data } = await httpClient.get(
      `${APP_URLs.commonEndPoints.getPopularEvents}/${
        query?.popularEventIds ?? ""
      }?${params.toString()}`,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const getEventInfoById = async (query: any) => {
  try {
    const { data } = await httpClient.get(
      `${APP_URLs.event.getEventInfoById}/${query?.eventId}?Skip=${query?.Skip}&Take=${query?.take}`,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const getInfoByEventChirpsId = async (query: any) => {
  const updateQuery =
    query?.itemName === "add document"
      ? "document"
      : query?.itemName === "create note"
      ? "note"
      : query?.itemName === "add website link"
      ? "web-links"
      : query?.itemName === "add rsvp"
      ? "event-rsvp"
      : query?.itemName === "add social media"
      ? "social-media-urls"
      : query?.itemName === "add checklist"
      ? "checklist"
      : query?.itemName === "add choicelist"
      ? "choicelist-option"
      : query?.itemName === "add vote or poll"
      ? "poll-option"
      : "";
  try {
    const { data } = await httpClient.get(
      `${APP_URLs.event.getEventByInforChipsId}/${query?.eventId}/${updateQuery}/${query?.eventInfoChirpId}`,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const getParticipantsByEventId = async (query: any) => {
  try {
    const { data } = await httpClient.get(
      `${APP_URLs.event.getParticipantsByEventIds}/${query?.eventId}`,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const getLocationList = async (query: any) => {
  try {
    const { data } = await httpClient.get(
      `${APP_URLs.commonEndPoints.getLocation}`,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};
const getMostSearchedLocation = async (query: any) => {
  try {
    const { data } = await httpClient.get(
      `${APP_URLs.commonEndPoints.getMostSearchedLocation}`,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const addLocation = async (payloadData: any) => {
  try {
    const { data } = await httpClient.post(
      APP_URLs.location.addLocation,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const editLocation = async (payloadData: any) => {
  try {
    const { data } = await httpClient.put(
      APP_URLs.location.addLocation,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const getAllEventCategoryList = async (query: any) => {
  try {
    const { data } = await httpClient.get(
      `${APP_URLs.event.getAllEventCategroyList}?id=${query?.id}&Skip=${
        query?.skip
      }&Take=${query?.take}&SearchText=${
        query?.SearchText
      }&OrderByColumn=${"Name"}&OrderByDirection=${"ASC"}`,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const getAllUsersList = async (query: any) => {
  try {
    const params = new URLSearchParams({
      roleId: query?.roleId,
      Skip: query?.skip,
      Take: query?.take,
      SearchText: query?.SearchText,
      OrderByColumn: query?.OrderByColumn ?? "firstName",
      OrderByDirection: query?.OrderByDirection ?? "ASC",
    });

    if (query?.isBanned !== undefined) {
      params.append("isBanned", query.isBanned);
    }

    if (query?.startDate) {
      params.append("startDate", query.startDate);
    }

    if (query?.endDate) {
      params.append("endDate", query.endDate);
    }

    const { data } = await httpClient.get(
      `${APP_URLs.genericUserAPI}?${params.toString()}`,
      config,
    );

    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const getAllEventContacts = async (query: any) => {
  try {
    const { data } = await httpClient.get(
      `${APP_URLs.event?.getAllEventContacts}?eventId=${query?.eventId}&Skip=${
        query?.skip
      }&Take=${query?.take}&SearchText=${
        query?.SearchText
      }&OrderByColumn=${"Sequence"}&OrderByDirection=${"ASC"}&isBanned=${
        query?.isBanned
      }`,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const getAllAdminUsersList = async (query: any) => {
  try {
    const { data } = await httpClient.get(
      `${APP_URLs.genericUserAPI}?roleId=${query?.roleId}&Skip=${
        query?.skip
      }&Take=${query?.take}&SearchText=${
        query?.SearchText
      }&OrderByColumn=${"CreatedOn"}&OrderByDirection=${"DESC"}`,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const getAllEventInfoTabsList = async (query: any) => {
  try {
    const { data } = await httpClient.get(
      `${APP_URLs.infotabs.getAllInfoTabs}?Skip=${query?.skip}&&Take=${
        query?.take
      }&SearchText=${
        query?.SearchText
      }&OrderByColumn=${"Sequence"}&OrderByDirection=${"ASC"}`,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const getEventInfoChirps = async (query: any) => {
  try {
    const { data } = await httpClient.get(
      `${APP_URLs.infotabs.getAllInfoTabs}`,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const getDashboardInfo = async (query: any) => {
  try {
    const { data } = await httpClient.get(
      `${APP_URLs.commonEndPoints.getDashboardInfo}`,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const getUserAnalytics = async (query: any) => {
  try {
    const params = new URLSearchParams({
      period: query?.period || "daily",
      startDate: query?.startDate || "",
      endDate: query?.endDate || "",
    });

    // const { data } = await httpClient.get(
    //   `${APP_URLs.commonEndPoints.getUserAnalytics}?${params.toString()}`,
    //   config,
    // );
    // return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const resetUserPassword = async (payloadData: any) => {
  try {
    const { data } = await httpClient.post(
      `${APP_URLs.authEndPoints.resetUserPassword}/${payloadData?.userId}`,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const sendEmailVerificationLink = async (payloadData: any) => {
  try {
    const email = payloadData?.email ?? payloadData;
    const { data } = await httpClient.post(
      `${APP_URLs.authEndPoints.sendVerificationLink}?email=${encodeURIComponent(
        email ?? "",
      )}`,
      {},
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const verifyUserEmail = async (payloadData: any) => {
  try {
    const userId = payloadData?.userId ?? payloadData;
    const { data } = await httpClient.post(
      `${APP_URLs.authEndPoints.verifyUserEmail}/${userId}`,
      {},
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};



//Blog

const getAllBlog = async (query: any) => {
  try {
    const params = new URLSearchParams({
      Skip: query?.skip,
      Take: query?.take,
      OrderByDirection: "ASC",
    });

    const { data } = await httpClient.get(
      `${APP_URLs.blog.genericURL}?${params.toString()}`,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const addBlog = async (payloadData: any) => {
  try {
    const { data } = await httpClient.post(
      APP_URLs.blog.genericURL,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const editBlog = async (payloadData: any) => {
  try {
    const { data } = await httpClient.put(
      APP_URLs.blog.genericURL,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const deleteBlog = async (payloadData: any) => {
  try {
    const { data } = await httpClient.delete(
      `${APP_URLs.blog.genericURL}/${payloadData?.id}`,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

// -----------> Category Bulk Upload <----------

const categoryBulkUpload = async (payloadData: any) => {
  try {
    const { data } = await httpClient.post(
      APP_URLs.commonEndPoints.bulkUpload,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

// -----------> App Config Youtube URL  <----------

const isMissingSettingError = (error: any) => error?.response?.status === 404;

const handleSettingError = (error: any) => {
  if (isMissingSettingError(error)) {
    return { result: null };
  }

  snackActions.dismissibleError(error?.message ?? "Something went wrong");
};

const addAppConfigSetting = async (payloadData: any) => {
  try {
    const { data } = await httpClient.post(
      APP_URLs.appConfig.updateDefaultCommissionUrl,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const getYoutubeUrl = async (query: any) => {
  try {
    const { data } = await httpClient.get(
      APP_URLs.appConfig.getYouTubUrl,
      config,
    );
    return data;
  } catch (error: any) {
    return handleSettingError(error);
  }
};

const updateYoutubeUrl = async (payloadData: any) => {
  try {
    const { data } = await httpClient.put(
      APP_URLs.appConfig.updateYouTubUrl,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

// -----------> App Config Youtube URL  <----------

const getDefaultCommission = async (query: any) => {
  try {
    const { data } = await httpClient.get(
      APP_URLs.appConfig.getDefaultCommissionUrl,
      config,
    );
    return data;
  } catch (error: any) {
    return handleSettingError(error);
  }
};

const updateDefaultCommission = async (payloadData: any) => {
  try {
    const { data } = await httpClient.put(
      APP_URLs.appConfig.updateDefaultCommissionUrl,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const getChatImageCompressionQuality = async (query: any) => {
  try {
    const { data } = await httpClient.get(
      APP_URLs.appConfig.getChatImageCompressionQualityUrl,
      config,
    );
    return data;
  } catch (error: any) {
    return handleSettingError(error);
  }
};

const updateChatImageCompressionQuality = async (payloadData: any) => {
  try {
    const { data } = await httpClient.put(
      APP_URLs.appConfig.updateChatImageCompressionQualityUrl,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const getChatVideoCompressionQuality = async (query: any) => {
  try {
    const { data } = await httpClient.get(
      APP_URLs.appConfig.getChatVideoCompressionQualityUrl,
      config,
    );
    return data;
  } catch (error: any) {
    return handleSettingError(error);
  }
};

const updateChatVideoCompressionQuality = async (payloadData: any) => {
  try {
    const { data } = await httpClient.put(
      APP_URLs.appConfig.updateChatVideoCompressionQualityUrl,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const getChatVideoMaxSize = async (query: any) => {
  try {
    const { data } = await httpClient.get(
      APP_URLs.appConfig.getChatVideoMaxSizeUrl,
      config,
    );
    return data;
  } catch (error: any) {
    return handleSettingError(error);
  }
};

const updateChatVideoMaxSize = async (payloadData: any) => {
  try {
    const { data } = await httpClient.put(
      APP_URLs.appConfig.updateChatVideoMaxSizeUrl,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const getRefundRequestWindowDays = async (query: any) => {
  try {
    const { data } = await httpClient.get(
      APP_URLs.appConfig.getRefundRequestWindowDaysUrl,
      config,
    );
    return data;
  } catch (error: any) {
    return handleSettingError(error);
  }
};

const updateRefundRequestWindowDays = async (payloadData: any) => {
  try {
    const { data } = await httpClient.put(
      APP_URLs.appConfig.updateRefundRequestWindowDaysUrl,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

// -----------> Mobile App Version  <----------

const getMobileAppVersionHistory = async (query?: any) => {
  try {
    const params = new URLSearchParams({
      Skip: String(query?.skip ?? 0),
      Take: String(query?.take ?? 100),
      SearchText: query?.SearchText ?? "",
      OrderByColumn: query?.OrderByColumn ?? "CreatedOn",
      OrderByDirection: query?.OrderByDirection ?? "DESC",
      TakeAll: String(query?.TakeAll ?? true),
    });

    const { data } = await httpClient.get(
      `${APP_URLs.appConfigVersion.appConfigHistoryUrl}?${params.toString()}`,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const getMobileAppVersion = async () => {
  try {
    const { data } = await httpClient.get(
      APP_URLs.appConfigVersion.appConfigVersionUrl,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const updateMobileAppVersion = async (payloadData: any) => {
  try {
    const { data } = await httpClient.put(
      APP_URLs.appConfigVersion.appConfigVersionUrl,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

// -----------> Add / Update Help Section <----------

const getHelpContent = async () => {
  try {
    const { data } = await httpClient.get(APP_URLs.help.getHelpContent, config);

    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const addHelpContent = async (payloadData: any) => {
  try {
    const { data } = await httpClient.post(
      APP_URLs.help.HelpContent,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const updateHelpContent = async (payloadData: any) => {
  try {
    const { data } = await httpClient.put(
      APP_URLs.help.HelpContent,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

// -----------> Add / Update Chat Help Section <----------

const getChatHelpContent = async () => {
  try {
    const { data } = await httpClient.get(
      APP_URLs.chatHelp.getCHatHelpContent,
      config,
    );

    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const addChatHelpContent = async (payloadData: any) => {
  try {
    const { data } = await httpClient.post(
      APP_URLs.chatHelp.chatHelpContent,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const updateChatHelpContent = async (payloadData: any) => {
  try {
    const { data } = await httpClient.put(
      APP_URLs.chatHelp.chatHelpContent,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

// -----------> Add / Update Payment Help Section <----------

const getPaymentHelpContent = async () => {
  try {
    const { data } = await httpClient.get(
      APP_URLs.paymentHelp.getPaymentHelpContent,
      config,
    );

    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const addPaymentHelpContent = async (payloadData: any) => {
  try {
    const { data } = await httpClient.post(
      APP_URLs.paymentHelp.paymentHelpContent,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const updatePaymentHelpContent = async (payloadData: any) => {
  try {
    const { data } = await httpClient.put(
      APP_URLs.paymentHelp.paymentHelpContent,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

// -----------> Contact Us Logs <----------

const getAllContactUs = async (query: any) => {
  try {
    const params = new URLSearchParams({
      Skip: query?.skip,
      Take: query?.take,
      OrderByDirection: "ASC",
    });

    const { data } = await httpClient.get(
      `${APP_URLs.contactUs.contactUsListURL}?${params.toString()}`,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

// -----------> Update Event Commission <----------

const updateEventCommission = async (payloadData: any) => {
  try {
    const { data } = await httpClient.put(
      APP_URLs.eventCommission.updateEventCommissionURL,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

// -----------> Admin Announcements <----------

const createAdminAnnouncement = async (payloadData: any) => {
  try {
    const { data } = await httpClient.post(
      APP_URLs.pushNotification.adminAnnouncement,
      payloadData,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const getAdminAnnouncements = async () => {
  try {
    const { data } = await httpClient.get(
      APP_URLs.pushNotification.adminAnnouncement,
      config,
    );
    return data;
  } catch (error: any) {
    snackActions.dismissibleError(error?.message ?? "Something went wrong");
  }
};

const updateAdminAnnouncement = async (payloadData: {
  id: number;
  title: string;
  description: string;
}) => {
  const response = await httpClient.put(
    `${APP_URLs.pushNotification.adminAnnouncement}/${payloadData.id}`,
    payloadData,
    config,
  );

  if (
    response.data !== undefined &&
    response.data !== null &&
    response.data !== ""
  ) {
    return response.data;
  }

  return {
    result: response.status >= 200 && response.status < 300,
  };
};

const deleteAdminAnnouncement = async (id: number) => {
  const response = await httpClient.delete(
    `${APP_URLs.pushNotification.adminAnnouncement}/${id}`,
    config,
  );

  if (
    response.data !== undefined &&
    response.data !== null &&
    response.data !== ""
  ) {
    return response.data;
  }

  return {
    result: response.status >= 200 && response.status < 300,
  };
};

export {
  addAboutUs,
  addAdmin,
  addBlog,
  addChatHelpContent,
  addChoiceList,
  addEvent,
  addEventCategory,
  addHelpContent,
  addInfoCheckList,
  addInfoDoc,
  addInfoImage,
  addInfoNote,
  addInfoPoll,
  addInfoRSVP,
  addInfoSocial,
  addInfoTab,
  addInfoWebURL,
  addLocation,
  addParticipants,
  addAppConfigSetting,
  addPaymentHelpContent,
  addPrivacy,
  addTerms,
  blockUsers,
  categoryBulkUpload,
  createAdminAnnouncement,
  deleteAdmin,
  deleteAdminAnnouncement,
  deleteBlog,
  deleteCategoryEvent,
  deleteEvents,
  deleteInfo,
  deleteLocation,
  editAdmin,
  editBlog,
  editEvent,
  editEventCategory,
  editInfoTab,
  editLocation,
  getAboutUs,
  getAdminAnnouncements,
  getAllAdminUsersList,
  getAllBlog,
  getAllContactUs,
  getAllEventCategoryList,
  getAllEventContacts,
  getAllEventInfoTabsList,
  getAllEventList,
  getPopularEventList,
  getAllUserList,
  getAllUsersList,
  getAppCustomerList,
  getChatHelpContent,
  getChatImageCompressionQuality,
  getChatVideoCompressionQuality,
  getChatVideoMaxSize,
  getCities,
  getCountries,
  getDashboardInfo,
  getDefaultCommission,
  getEventCategory,
  getEventInfoById,
  getEventInfoChirps,
  getHelpContent,
  getInfoByEventChirpsId,
  getLocationList,
  getLocationLists,
  getMobileAppVersion,
  getMobileAppVersionHistory,
  getMostSearchedLocation,
  getParticipantsByEventId,
  getPaymentHelpContent,
  getPrivacy,
  getProfileImg,
  getRefundRequestWindowDays,
  getStates,
  getTerms,
  getUserAnalytics,
  getUsers,
  getYoutubeUrl,
  resetPassword,
  resetUserPassword,
  sendEmailVerificationLink,
  sendOTP,
  updateChatHelpContent,
  updateChatImageCompressionQuality,
  updateChatVideoCompressionQuality,
  updateChatVideoMaxSize,
  updateDefaultCommission,
  updateAdminAnnouncement,
  updateEventCommission,
  updateHelpContent,
  updateMobileAppVersion,
  updatePaymentHelpContent,
  updateRefundRequestWindowDays,
  updateYoutubeUrl,
  uploadPicture,
  verifyOTP,
  verifyUserEmail,
};
